module.exports = __webpack_public_path__ + "img/pdf.d0f4c19f.png";